<template>
  <CFormItem :prop="name" :field-value="value" class="cell-obj-sel">
    <ElInput
      v-model="textValue"
      readonly
      @keydown.stop="noop"
      @click.stop="noop"
    >
      <template #suffix>
        <ElButton type="primary" link @click="selectObj">...</ElButton>
      </template>
    </ElInput>
  </CFormItem>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { ICellRendererParams } from 'ag-grid-community';
import { IdLabel } from '../../core/types';
import { noop } from 'lodash-es';

const props = defineProps<{
  params: ICellRendererParams<any> & {
    /*编辑框是否禁用 */
    disabled?: boolean | string | ((ps: ICellRendererParams<any>) => boolean);

    callback: (params: ICellRendererParams<any>) => Promise<IdLabel>;

    textField: string; // 显示的文字字段

    valueChange?: (
      params: ICellRendererParams<any>,
      newValue: any,
      oldValue: string
    ) => void;
  };
}>();

// 字段名
// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
const name = props.params.colDef!.field!;

const textValue = ref(props.params.data[props.params.textField]);

const value = ref(props.params.value);

async function selectObj() {
  const idLabel = await props.params.callback(props.params);

  const oldValue = props.params.value;
  const oldText = textValue.value;
  const newValue = idLabel.id;
  const newText = idLabel.label;
  try {
    await props.params.valueChange?.(props.params, newValue, oldValue);

    // eslint-disable-next-line vue/no-mutating-props
    props.params.data[props.params.textField] = newText;
    textValue.value = newText;

    props.params.node.setDataValue(name, newValue, 'form'); // 'form'参数用于区分谁触发的
  } catch (e) {
    textValue.value = oldText;
    throw e;
  }
}
</script>

<style lang="scss">
.cell-obj-sel {
  .el-input {
    width: calc(100% - 22px) !important;
    box-sizing: border-box;
    margin-left: 11px;
    margin-right: 11px;
    vertical-align: middle !important;

    &.is-disabled {
      cursor: default !important;

      .el-input__wrapper {
        --el-disabled-bg-color: transparent;
        --el-disabled-text-color: var(--el-input-text-color);

        border-color: transparent !important;
        box-shadow: none !important;

        input {
          cursor: default;
        }
      }
    }

    .el-input__wrapper {
      border: 1px solid #dcdfe655;
      box-shadow: none;
      padding: 1px 2px 1px 11px;
    }

    .el-input__wrapper:hover,
    .el-input__wrapper.is-focus {
      border-color: #dcdfe6;
      box-shadow: none;
    }

    .el-input__inner {
      height: var(--el-input-inner-height);
    }
  }

  .el-button {
    width: 24px;
    span {
      margin-bottom: 6px;
    }
  }
}
</style>
